export const TREND_LINE_BORDER_DASH = [5, 5];
export const TREND_LINE_POINT_RADIUS = 3;
export const TREND_LINE_LABEL_SUFFIX = ' (trend)';
